const toRem = (pxValue: number, appendUnit = true, pixelsPerRem = 16) =>
  Number(pxValue) === 0 ? 0 : `${Number(pxValue) / pixelsPerRem}${appendUnit ? `rem` : ``}`;
export default toRem;
